'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import AdjacentPortal from './AdjacentPortal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class AfterEndPortal extends Component {
  render() {
    const {
      id,
      namespace,
      targetElement,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(AdjacentPortal, {
      id: id,
      namespace: namespace,
      targetElement: targetElement,
      targetPosition: 'afterend',
      children: children
    });
  }
}
AfterEndPortal.propTypes = {
  id: PropTypes.string.isRequired,
  namespace: PropTypes.string,
  targetElement: PropTypes.instanceOf(Element).isRequired,
  children: PropTypes.node.isRequired
};